import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import './NuevoDashboard.css';
import { formatSoles } from '../../Global';

const DashboardVentasMes = ({ 
    dataVentasPorSemana, 
    MesActual, 
    dataSucursales, 
    handleSucursalChangeMes, 
    idSucursal,
    fechaInicio,
    fechaFin,
    minFechaMes,
    maxFechaMes,
    handleFechaInicioChangeMes,
    handleFechaFinChangeMes
}) => {
    const tieneDatos = dataVentasPorSemana && 
                      dataVentasPorSemana.respuesta && 
                      Array.isArray(dataVentasPorSemana.respuesta) && 
                      dataVentasPorSemana.respuesta.length > 0;
    
    if (!tieneDatos) {
        return (
            <div className="dashboard-container">
                <div className="loading-state">
                    <div className="spinner"></div>
                    <h3>Cargando datos de ventas...</h3>
                </div>
            </div>
        );
    }

    const respuestaData = dataVentasPorSemana.respuesta;
    const estadisticas = dataVentasPorSemana.estadisticas && dataVentasPorSemana.estadisticas[0] 
        ? dataVentasPorSemana.estadisticas[0] 
        : {};

    const salesData = respuestaData.map(semana => ({
        semana: `${semana.Semana}`,
        ventas: (semana.Ventas || 0),
        compras: (semana.Compras || 0),
        cantidadVentas: (semana.CantidadVentas || 0),
        cantidadCompras: (semana.CantidadCompras || 0)
    }));

    const Balance = ((estadisticas.TotalVentas || 0) - (estadisticas.TotalCompras || 0));

    return (
        <div className="dashboard-container">
            <div className="dashboard-header">

                {/* Filtros de Fecha y Sucursal */}
                <div style={{ 
                    border: '1px solid #01a59c',
                    backgroundColor: '#dbedec',
                    padding: '15px', 
                    borderRadius: '1.25rem', 
                    marginBottom: '20px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    <div className="row">
                        <div className="col-md-3 mb-2">
                            <label className="form-label"><strong>Fecha Inicio:</strong></label>
                            <input
                                className="form-control"
                                name="fechaInicioMes"
                                type="date"
                                value={fechaInicio}
                                min={minFechaMes}
                                max={maxFechaMes}
                                onChange={handleFechaInicioChangeMes}
                            />
                        </div>
                        <div className="col-md-3 mb-2">
                            <label className="form-label"><strong>Fecha Fin:</strong></label>
                            <input
                                className="form-control"
                                name="fechaFinMes"
                                type="date"
                                value={fechaFin}
                                min={minFechaMes}
                                max={maxFechaMes}
                                onChange={handleFechaFinChangeMes}
                            />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label className="form-label"><strong>Sucursal:</strong></label>
                            <select
                            className="form-control"
                            name="sucursal"
                            value={idSucursal || ""}
                            onChange={handleSucursalChangeMes}
                            >
                            <option value="">Sucursal actual</option>
                            {dataSucursales && dataSucursales.map(sucursal => (
                                <option
                                key={sucursal.IdSucursal}
                                value={sucursal.IdSucursal}
                                title={sucursal.Nombre}
                                >
                                {sucursal.Nombre}
                                </option>
                            ))}
                            </select>
                        </div>
                    </div>
                </div>
                <h2 className="text-center">Dashboard de Ventas - {MesActual}</h2>
                <div className="header-stats">
                    <div className="stat-card primary">
                        <span className="stat-label">Total Ventas</span>
                        <span className="stat-value">S/ {formatSoles(estadisticas.TotalVentas || 0)}</span>
                    </div>
                    <div className="stat-card secondary">
                        <span className="stat-label">Total Compras</span>
                        <span className="stat-value">S/ {formatSoles(estadisticas.TotalCompras || 0)}</span>
                    </div>
                    <div className={`stat-card ${Balance >= 0 ? 'success' : 'danger'}`}>
                        <span className="stat-label">Balance</span>
                        <span className="stat-value">S/ {formatSoles(Balance || 0)}</span>
                    </div>
                </div>

                <div className="header-stats">
                    <div className="stat-card info">
                        <span className="stat-label">Total Transacciones Ventas</span>
                        <span className="stat-value">{estadisticas.TotalCantidadVentas || 0}</span>
                    </div>
                    <div className="stat-card dark">
                        <span className="stat-label">Total Transacciones Compras</span>
                        <span className="stat-value">{estadisticas.TotalCantidadCompras || 0}</span>
                    </div>
                </div>
            </div>

            <div className="dashboard-content">
                <div className="chart-container">
                    <h3>Ventas y Compras por Semana</h3>
                    <ResponsiveContainer width="100%" height={400}>
                        <BarChart
                            data={salesData}
                            margin={{
                                top: 20,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="semana" />
                            <YAxis tickFormatter={(value) => ` ${formatSoles(value)}`}/>
                            <Tooltip            
                                formatter={(value, name) => {
                                    if (name === 'ventas' || name === 'compras') {
                                        return [`S/ ${formatSoles(value)}`, name === 'ventas' ? 'Ventas' : 'Compras'];
                                    }
                                    return [formatSoles(value), name];
                                }}
                            />
                            <Legend />
                            <Bar dataKey="ventas" fill="#4CAF50" name="Ventas" />
                            <Bar dataKey="compras" fill="#F44336" name="Compras" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                <div className="chart-container">
                    <h3>Cantidad de Transacciones por Semana</h3>
                    <ResponsiveContainer width="100%" height={400}>
                        <BarChart
                            data={salesData}
                            margin={{
                                top: 20,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="semana" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="cantidadVentas" fill="#2196F3" name="Transacciones Ventas" />
                            <Bar dataKey="cantidadCompras" fill="#9C27B0" name="Transacciones Compras" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                <div className="weekly-breakdown">
                    <h3 className="text-center">Desglose Semanal Completo</h3>
                    <div className="weekly-cards">
                        {salesData.map((item, index) => {
                            const weeklyBalance = (item.ventas - item.compras);
                            return (
                                <div key={index} className="week-card">
                                    <h4 className="text-center">{item.semana}</h4>
                                    <div className="week-stats">
                                        <div className="week-stat">
                                            <span className="week-label">Ventas</span>
                                            <span className="week-value sales">S/ {formatSoles(item.ventas)}</span>
                                        </div>
                                        <div className="week-stat">
                                            <span className="week-label">Compras</span>
                                            <span className="week-value purchases">S/ {formatSoles(item.compras)}</span>
                                        </div>
                                        <div className="week-stat">
                                            <span className="week-label">Balance</span>
                                            <span className={`week-value ${weeklyBalance >= 0 ? 'positive' : 'negative'}`}>
                                                S/ {formatSoles(weeklyBalance || 0)}
                                            </span>
                                        </div>
                                        <div className="week-stat">
                                            <span className="week-label">Trans. Ventas</span>
                                            <span className="week-value info">{item.cantidadVentas}</span>
                                        </div>
                                        <div className="week-stat">
                                            <span className="week-label">Trans. Compras</span>
                                            <span className="week-value dark">{item.cantidadCompras}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="stats-highlights">
                    <div className="highlight-card">
                        <h4 className="text-center">Máximo y Mínimo</h4>
                        <div className="highlight-content">
                            <div className="highlight-item">
                                <span className="highlight-label">{estadisticas.SemanaMayorVenta}</span>
                                <span className="highlight-label">Mayor Venta</span>
                                <span className="highlight-value sales">S/ {formatSoles(estadisticas.MayorVenta || 0)}</span>
                                <span className="highlight-label">Cantidad</span>
                                <span className="highlight-value info">{estadisticas.MayorCantidadVentas || 0}</span>
                            </div>
                            <div className="highlight-item">
                                <span className="highlight-label">{estadisticas.SemanaMayorCompra}</span>
                                <span className="highlight-label">Mayor Compra</span>
                                <span className="highlight-value sales">S/ {formatSoles(estadisticas.MayorCompra || 0)}</span>
                                <span className="highlight-label">Cantidad</span>
                                <span className="highlight-value info">{estadisticas.MayorCantidadCompras || 0}</span>
                            </div>
                            <div className="highlight-item">
                                <span className="highlight-label">{estadisticas.SemanaMenorVenta}</span>
                                <span className="highlight-label">Menor Venta</span>
                                <span className="highlight-value purchases">S/ {formatSoles(estadisticas.MenorVenta || 0)}</span>
                                <span className="highlight-label">Cantidad</span>
                                <span className="highlight-value info">{estadisticas.MenorCantidadVentas || 0}</span>
                            </div>
                            <div className="highlight-item">
                                <span className="highlight-label">{estadisticas.SemanaMenorCompra}</span>
                                <span className="highlight-label">Menor Compra</span>
                                <span className="highlight-value purchases">S/ {formatSoles(estadisticas.MenorCompra || 0)}</span>
                                <span className="highlight-label">Cantidad</span>
                                <span className="highlight-value info">{estadisticas.MenorCantidadCompras || 0}</span>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    );
};

export default DashboardVentasMes;
